import app from './episodesingle';

app.$mount('#episodesingle');
